module.exports = __webpack_public_path__ + "img/EG.cc1152ac.png";